import { TextArea } from '@lifeomic/chroma-react/components/TextArea';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  textArea: {
    resize: 'none',
    height: theme.pxToRem(100),
  },
}));

const messages = defineMessages({
  instructions: {
    id: 'ExecutiveSummary.GenerateMenuModal.Instructions',
    defaultMessage: 'Instructions (optional)',
  },
  instructionsRequired: {
    id: 'ExecutiveSummary.GenerateMenuModal.instructionsRequired',
    defaultMessage: 'Instructions',
  },
  placeholderInstructions: {
    id: 'ExecutiveSummary.GenerateMenuModal.placeholderInstructions',
    defaultMessage:
      'Enter any additional instructions for the report (re)generation (e.g., "Output in Spanish" or reference a specific body part).',
  },
});

type InstructionsProps = {
  instructions: string;
  setInstructions: (instructions: string) => void;
  isRequired: boolean;
};

export const Instructions = ({
  instructions,
  setInstructions,
  isRequired = false,
}: InstructionsProps) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <TextArea
      label={formatMessage(
        isRequired ? messages.instructionsRequired : messages.instructions,
      )}
      placeholder={formatMessage(messages.placeholderInstructions)}
      value={instructions}
      onChange={e => setInstructions(e.target.value)}
      fullWidth
      textAreaClassName={classes.textArea}
    />
  );
};
